module.exports = __webpack_public_path__ + "img/13.8bf9dae2.png";